export const SHOW_HIDE_LOADER = "SHOW_HIDE_LOADER";
export const SHOW_HIDE_LOADER_TEXT = "SHOW_HIDE_LOADER_TEXT";

export const HIDE_LOADER_OVERLAY = "HIDE_LOADER_OVERLAY";
